import { Heading } from '@graftcode/design-system'

import { VIDEOS_TEST_IDS } from '../../videos.const'

import styles from './VideosHeader.module.scss'

export function VideosHeader() {
  return (
    <div className={styles.header} data-testid={VIDEOS_TEST_IDS.header}>
      <Heading className={styles.title} type="h1">
        Videos
      </Heading>
    </div>
  )
}
